import react, { useState, useEffect } from "react";
import {Grid, Typography, Container, Button} from "@mui/material";
import Api from "../services/Api";
import { NewOptimizationCard } from "../components/NewOptimizationCard";
import { OptimizationCard } from "../components/OptimizationCard";
import { useHistory } from "react-router-dom";
import { useUserInfoContext } from "../contexts/UserInfoContext";
import UserUtils from "../utils/userUtils";
import { UnauthorizedPage } from "../components/auth/Unauthorized";
import useDocumentTitle from "../hooks/useDocumentTitle";
import moment from "moment";


export const NewOptimizationView = (props) => {
  const {isAuthorized, checkIfUserHasRole} = useUserInfoContext();
  const [optimizations, setOptimizations] = useState([]);
  const history = useHistory();
  // const [pw, setPw] = useState("");
  const [verified, setVerified] = useState(false);

  useDocumentTitle("Optimizations");

  useEffect(() => {
    getData();
  }, [])

  const getData = async () => {
    let opts = await Api.getAllOptimizationRequests();
    if (opts != null){
      opts.sort(sortOptimizationsByDateTime);
      setOptimizations(opts);
    }
  }

  const sortOptimizationsByDateTime = (a, b) => {
    let dateA = moment(a.dateRequested);
    let dateB = moment(b.dateRequested);
    if (!dateA.isValid()){
      return -1;
    }
    if (!dateB.isValid()){
      return 1;
    }
    console.log(dateA, dateB);
    return dateB.diff(dateA);
  }

  const postNewRequest = async (request) => {
    let newResult = await Api.postNewOptimizationRequest(request);
    await getData();
    return (newResult !== null)
  }

  const onCardClick = async (request) => {
    let fullOpt = await Api.getOptimizationRequestById(request.id);
    history.push("/optimization/view", {optimization: fullOpt});
  }

  // const verify = async (pw) => {
  //   var success = await Api.postOptLogin(pw);
  //   if (success){
  //     setVerified(true);
  //     setPw(pw);
  //   }
  // }
  const onErrorClick = async (opt) => {
    let success = await Api.deleteErrorOptimization(opt.id);
    if (success){
      await getData();
    }
  }


  return (
    <Container>
      {checkIfUserHasRole(UserUtils.RoleObjects['powerUser'].name) ? 
      <>
      {isAuthorized &&
        <NewOptimizationCard submit={postNewRequest} />
      }
        <Grid container justifyContent={"center"} spacing={1} sx={{paddingTop: "1em", paddingBottom:"2em"}}>
          <Grid item xs={10}>
            <Typography variant="h5">
              Recommended Schedules
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Button variant="outlined" onClick={() => getData()}>
              Refresh
            </Button>
          </Grid>
          {optimizations.map(x => 
            <Grid item xs={8} key={x.id}>
              <OptimizationCard data={x} onClick={onCardClick} onErrorClick={onErrorClick}/>
            </Grid>
          )}
        </Grid>
      </>
       :
      <UnauthorizedPage home={true} />
      }
    </Container>
  )

}

export default NewOptimizationView;